@if (formList) {
  <form [formGroup]="claimSubmitForm" class="ClaimSubmission__FormGroup">
    @for (item of formList; track item) {
      <div
        [ngStyle]="{ order: item.value.position }"
        [ngClass]="{
          ClaimSubmission__Form: item.key !== 'claimLineInformation',
        }"
        [id]="item.key"
      >
        @if (item.key !== 'claimLineInformation') {
          <div class="ClaimSubmission__Title">
            <h6 class="ClaimSubmission__Heading">
              {{ item.value.title }}
            </h6>
            <p
              class="ClaimSubmission__Details"
              [innerHTML]="item.value.description"
            ></p>
          </div>
        }
        <ng-container body>
          @switch (item.key) {
            @case ('patientInformation') {
              <form-group
                class="ClaimSubmissionForm__Group"
                [form]="claimSubmitForm.get(item.key)"
                [configs]="item.value.patientInformationForm.controls"
                [context]="patientInformationContext"
                direction="action"
                data-test-id="patientInformationForm"
              ></form-group>
            }
            @case ('providerInformation') {
              <form-group
                class="ClaimSubmissionForm__Group"
                [form]="claimSubmitForm.get(item.key)"
                [configs]="item.value.providerInformationForm.controls"
                [context]="providerInformationContext"
                direction="action"
                data-test-id="providerInformationForm"
              ></form-group>
            }
            @case ('claimLineInformation') {
              <form-group
                [form]="claimSubmitForm.get(item.key)"
                [configs]="item.value.claimLineInformationForm.controls"
                [context]="claimLineContext"
                direction="action"
                data-test-id="claimLineInformationForm"
              ></form-group>
            }
            @case ('serviceDetails') {
              <form-group
                class="ClaimSubmissionForm__Group"
                [form]="claimSubmitForm.get(item.key)"
                [configs]="item.value.serviceDetailsForm.controls"
                [context]="serviceDetailContext"
                direction="action"
                data-test-id="serviceDetailsForm"
              ></form-group>
            }
            @case ('dentalTreatment') {
              <form-group
                class="ClaimSubmissionForm__Group"
                [form]="claimSubmitForm.get(item.key)"
                [configs]="item.value.dentalTreatmentForm.controls"
                [context]="dentalTreatmentContext"
                direction="action"
                data-test-id="dentalTreatmentForm"
              ></form-group>
            }
            @case ('supportingDocumentation') {
              <zip-supporting-documentation
                [config]="item.value"
                [context]="supportingDocumentsContext"
                data-test-id="supportingDocumentation"
              ></zip-supporting-documentation>
            }
          }
        </ng-container>
      </div>
    }
  </form>
}
